import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { scormActions } from '../redux/actions';

const useScormProgress = (resourceType, registrationId, repoId) => {
    const dispatch = useDispatch();

    const { progress, loading, error } = useSelector((state) => state.scorm);

    useEffect(() => {
        if (resourceType === 'presentacion' && registrationId && repoId) {
            dispatch(
                scormActions.getScormProgressRequest(registrationId, repoId)
            );
        }
    }, [resourceType, registrationId, repoId, dispatch]);

    const refreshProgress = () => {
        if (resourceType === 'presentacion' && registrationId && repoId) {
            dispatch(
                scormActions.getScormProgressRequest(registrationId, repoId)
            );
        }
    };

    return {
        progress,
        loading,
        error,
        refreshProgress,
    };
};

export default useScormProgress;
